/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGaugeRating = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M6 6c.388 0 .74.225.905.575l1.01 2.15 2.236.343a.999.999 0 0 1 .565 1.686l-1.648 1.689.391 2.396a1 1 0 0 1-1.47 1.036L6 14.777l-1.99 1.098a.998.998 0 0 1-1.47-1.036l.392-2.396-1.648-1.69a1 1 0 0 1 .565-1.685l2.236-.342 1.01-2.151C5.26 6.225 5.612 6 6 6zm12 0c.388 0 .74.225.905.575l1.01 2.15 2.236.343a.999.999 0 0 1 .565 1.686l-1.648 1.689.391 2.396a1 1 0 0 1-1.47 1.036L18 14.777l-1.989 1.098a.998.998 0 0 1-1.47-1.036l.391-2.396-1.648-1.69a1 1 0 0 1 .565-1.685l2.236-.342 1.01-2.151C17.26 6.225 17.612 6 18 6zM6 9.354l-.331.705a.996.996 0 0 1-.754.563l-.84.129.64.656a1 1 0 0 1 .272.86l-.141.862.67-.37a1.003 1.003 0 0 1 .968 0l.67.37-.141-.862a1 1 0 0 1 .271-.86l.641-.656-.84-.13a.996.996 0 0 1-.754-.562zm12 0-.331.705a.996.996 0 0 1-.754.563l-.84.129.641.656a1 1 0 0 1 .271.86l-.141.862.67-.37a1.003 1.003 0 0 1 .968 0l.67.37-.14-.862a1 1 0 0 1 .27-.86l.641-.656-.84-.13a.996.996 0 0 1-.754-.562z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgGaugeRating as GaugeRating };
